import './Graphs/graphStyles.scss'
import { CSVLink } from "react-csv";

export function ExportCSVButton({ allData, name, style, title="Export to CSV" }) {
    const csvData = [
        ['CausalFunnel Dashboard Generated Report'], 
        ['Report Generated On: ' + new Date().toLocaleString()],
        ['  '], 
        ...allData
    ];

    const filename = `${name}.csv`.replace(/\s+/g, '_');

    return (
        <CSVLink 
            data={csvData} 
            filename={filename}
            style={{ textDecoration: 'none' }}
            target="_blank"
        >
            <button 
                className='csv__button' 
                style={style}
            >
                {title}
            </button>
        </CSVLink>
    )
}